import { NavMenu as NavMenuBase } from './nav-menu';
import { NavMenuItem } from './nav-menu-item';

export const NavMenu = Object.assign(NavMenuBase, {
	Item: NavMenuItem,
});
